export const queryStringToObject = (query) => {
    const urlParams = new URLSearchParams(query);
    const entries = urlParams.entries();
    const result = {};
    for (const [key, value] of entries) {
        result[key] = value;
    }
    return result;
};